import React from 'react';
import DataListAllBoxes from './DataListAllBoxes';



const AllBoxesCom = ({title,data}) => {
    const data_ = [
        { name: 'إجمالي الداخل', value: data.topOfThePage.totalIn },
        { name: 'إجمالي الخارج', value:  data.topOfThePage.totalOut},
        { name: 'إجمالي الموجود', value: data.topOfThePage.current }
      ];
    return (
        <div className='CardWithPie-Parent'>
            <div><h3>{title}</h3></div>
            <div >
                <div>
                <DataListAllBoxes data={data_}/>
                </div>
               
            </div>
        </div>
    );
}

export default AllBoxesCom;